import React from 'react';
import '../../App.css';
import HeroSection from '../assetsSpanish/HeroSection';
import Footer from '../assetsSpanish/Footer';

function Home() {
  return (
    <>
      <HeroSection />
      <Footer />
    </>
  );
}

export default Home;
